import { msg } from "../locales/translate";
import type { IStatementRow } from "src/types/statement";

export const isTransitionStatement = (statement: Pick<IStatementRow, "is_transition" | "data">): boolean => {
	if (statement.is_transition !== undefined && statement.is_transition !== null) {
		return statement.is_transition === 1 || statement.is_transition === true;
	}
	return statement.data?.transition === true || statement.data?.transition === 1 || statement.data?.mode === "transition";
};

export const getStatementTypeLabel = (type?: string | null): string => {
	const value = type?.trim().replace(/[_-]+/g, " ");
	if (!value) return msg("notSpecified");
	return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};
